import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, Table, Button } from "reactstrap"
import { TiTick } from "react-icons/ti"
import { MdCancel } from "react-icons/md"
import Configs from "../../config"

const ViewDocumentModal = ({ isOpen, toggle, documents, onStatusChange }) => {
  const [previewImage, setPreviewImage] = useState(null)

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="lg" centered scrollable>
        <ModalHeader toggle={toggle} className="border-bottom">
          <h5 className="mb-0">Employee Documents</h5>
        </ModalHeader>
        <ModalBody className="p-0">
          <div className="table-responsive">
            <Table className="mb-0 align-middle" hover>
              <thead className="table-light">
                <tr>
                  <th style={{ width: "50px" }}>#</th>
                  <th style={{ minWidth: "150px" }}>Document Name</th>
                  <th style={{ minWidth: "120px" }}>Number</th>
                  <th style={{ width: "100px" }}>Preview</th>
                  <th style={{ width: "100px" }}>Status</th>
                  <th style={{ width: "120px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documents && documents.length > 0 ? (
                  documents.map((doc, index) => (
                    <tr key={doc.id}>
                      <td className="text-muted fw-medium">{index + 1}</td>
                      <td className="fw-medium">{doc.name}</td>
                      <td className="text-muted">{doc.value || "-"}</td>
                      <td>
                        <div
                          className="position-relative overflow-hidden rounded border"
                          style={{
                            width: "70px",
                            height: "50px",
                            cursor: "pointer",
                            transition: "transform 0.2s",
                          }}
                          onClick={() =>
                            setPreviewImage(
                              `${Configs.imageUrl}${doc.attachment}`
                            )
                          }
                          onMouseEnter={e =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseLeave={e =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        >
                          <img
                            src={`${Configs.imageUrl}${doc.attachment}`}
                            alt={doc.name}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            doc.status === true
                              ? "bg-success"
                              : doc.status === false
                              ? "bg-danger"
                              : "bg-warning text-dark"
                          } text-capitalize`}
                          style={{ minWidth: "75px", display: "inline-block" }}
                        >
                          {doc.status === true
                            ? "Approved"
                            : doc.status === false
                            ? "Rejected"
                            : "Pending"}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            size="sm"
                            color="success"
                            outline={doc.status === "approved"}
                            disabled={doc.status === "approved"}
                            onClick={() => onStatusChange(doc.id, true)}
                            title="Approve"
                            className="d-flex align-items-center"
                          >
                            <TiTick size={18} />
                          </Button>
                          <Button
                            size="sm"
                            color="danger"
                            outline={doc.status === "rejected"}
                            disabled={doc.status === "rejected"}
                            onClick={() => onStatusChange(doc.id, false)}
                            title="Reject"
                            className="d-flex align-items-center"
                          >
                            <MdCancel size={18} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-5">
                      <div>
                        <p className="mb-0">No documents found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>

      {/* Fullscreen Preview */}
      {previewImage && (
        <Modal
          isOpen={!!previewImage}
          toggle={() => setPreviewImage(null)}
          size="lg"
          centered
        >
          <ModalHeader toggle={() => setPreviewImage(null)}>
            Document Preview
          </ModalHeader>
          <ModalBody className="text-center p-4">
            <img
              src={previewImage}
              alt="Preview"
              className="img-fluid rounded shadow-sm"
              style={{ maxHeight: "70vh", objectFit: "contain" }}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

export default ViewDocumentModal
